import * as React from 'react';

import useAuthApi from '../../../hooks/useAuthApi';
import Button from '../../base/buttons/Button';
import LoginHeader from '../LoginHeader';
import LoginTitle from '../LoginTitle';

interface IForgotPasswordStepProps {
  email: string;
  onNext: (result: { requiresSmsOtp: boolean; phoneLast4?: string }) => void;
  onBack: () => void;
}

const ForgotPasswordStep = ({ email, onNext, onBack }: IForgotPasswordStepProps) => {
  const authApi = useAuthApi();
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSendReset = React.useCallback(async () => {
    setIsSubmitting(true);
    const result = await authApi.forgotPassword({ email });
    setIsSubmitting(false);

    // Always transition regardless of result (API always returns success for privacy)
    onNext({
      requiresSmsOtp: result.ok ? result.data.requiresSmsOtp : false,
      phoneLast4: result.ok ? result.data.phoneLast4 : undefined,
    });
  }, [authApi, email, onNext]);

  return (
    <>
      <LoginHeader onBack={onBack} />
      <LoginTitle title="Forgot password?" />

      <div className="flex w-full flex-col gap-4">
        <span className="text-secondary text-sm">
          We&apos;ll send a password reset code to <span className="text-primary font-medium">{email}</span>.
        </span>

        <Button size="xl" color="primary" className="w-full" onClick={handleSendReset} isLoading={isSubmitting}>
          Send reset code
        </Button>
      </div>
    </>
  );
};

ForgotPasswordStep.displayName = 'ForgotPasswordStep';

export default ForgotPasswordStep;
